import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Observable, Subscription, filter } from 'rxjs';
import { IOPayload } from 'src/app/model/io-payload';
import { Device } from 'src/app/model/device';
import { selectInputEdited, selectInputEditing } from 'src/app/store/device/device.selector';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	templateUrl: './edit-input.dialog.component.html',
})

export class EditInputDialogComponent  implements OnInit, OnDestroy {
	inputEditing$: Observable<boolean | undefined>;
	inputEditingSub: Subscription | undefined;
	inputEdited$: Observable<boolean | undefined>;
	inputEditedSub: Subscription | undefined;

	multiIOForm: FormGroup;
	terminal: IOPayload;
	device: Device;
	inputEditing: boolean;

	stateActiveOpt: any[];

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	){
		this.stateActiveOpt = [
			{ value: 0, label: 'LOW' },
			{ value: 1, label: 'HIGH' }
		]
		if (config.data !== undefined && config.data.terminal !== undefined) {
			this.terminal = config.data.terminal;
		}
		if (config.data !== undefined && config.data.device !== undefined) {
			this.device = config.data.device;
		}
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	buildForm(): void {
		this.multiIOForm = new FormGroup({
			'activeState': new FormControl(this.terminal.StateLabelActive, Validators.required),
			'inactiveState': new FormControl(this.terminal.StateLabelInactive, Validators.required),
			'stateActive': new FormControl(this.terminal.StateActive, Validators.required),
		});
	}

	initSelectors(): void{
		this.inputEditing$ = this.store.select(selectInputEditing);
		this.inputEdited$ = this.store.select(selectInputEdited);
	}

	subscribeAll(): void {
		this.inputEditingSub = this.inputEditing$?.subscribe(
			(inputEditing) => {
				this.inputEditing = inputEditing;
			}
		);
		this.inputEditedSub = this.inputEdited$?.pipe(filter(edit => !!edit))
			.subscribe(() => {
				this.resetClose();
		});
	}

	ngOnDestroy(): void {
		this.inputEditingSub?.unsubscribe();
		this.inputEditedSub?.unsubscribe();
	}

	resetClose(): void {
		this.store.dispatch(DeviceActions.ioDialogReset());
		this.closeDialog();
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.multiIOForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.multiIOForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		const ioPayload: IOPayload = {
			InputId: this.terminal.InputId,
			StateLabelActive: this.f.activeState.value,
			StateLabelInactive: this.f.inactiveState.value,
			StateActive: this.f.stateActive.value
		};

		this.store.dispatch(DeviceActions.editMultiIO({ device: this.device, ioPayload }));
	}

	get f(): any {
		return this.multiIOForm.controls;
	}

	closeDialog(): void{
		this.ref.close();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	underTablet(): boolean {
		return StandardPageLayout.underTablet(this.screenWidth);
	}

	col12Responsive() : string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	customPaddingX() : string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

	dynamicButtonWidth() : string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	justifyContentStyle() : string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: EditInputDialogComponent["f"], classType: string) : string {
		return StandardNewValidator.newShowErrors(type,classType,this.screenWidth);
	}

	showErrorRequiredMessage(type: EditInputDialogComponent["f"]) : boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth,'w-18rem');
	}
}
